export const shortenTextMask = (name: string, size: number) => `${name ? name.slice(0, size).trim() : "-"}${name && name.length > size ? "..." : ""}`;



// WEBPACK FOOTER //
// ./src/util/Masks/StringMask.ts